export default __webpack_public_path__ + "static/media/MasterCard.b720e3b5.svg";